import {HttpErrorResponse} from '@angular/common/http';
import {Component, Inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';

interface RawPublicationOption {
  name: string;
  conditions: (string | boolean)[];
}

interface PublicationOption {
  name: string;
  conditions: Condition[];
}

interface Condition {
  name: string;
  met: boolean;
}

export interface PublicationValidationErrorData {
  isSpeculation: boolean;
  isDirect: boolean;
  error: HttpErrorResponse;
}

@Component({
  selector: 'app-file-publication-validation-dialog',
  imports: [MatDialogActions, MatDialogClose, MatIconModule, MatButtonModule],
  templateUrl: './file-publication-validation-dialog.component.html',
  styleUrl: './file-publication-validation-dialog.component.scss',
})
export class FilePublicationValidationDialogComponent {
  title: string;
  explainer: string;
  options: PublicationOption[];

  constructor(@Inject(MAT_DIALOG_DATA) dialogData: PublicationValidationErrorData) {
    if (dialogData.isDirect) {
      if (dialogData.isSpeculation) {
        this.title = 'Why are the "Dataset File Visibility" options disabled?';
      } else {
        this.title = 'Unable to change the "Dataset File Visibility" option.';
      }
      this.explainer = `Below are the requirements which must be met in order to change the visibility setting for the current dataset file version. 

You may also need to contact the system administrator to address any HIPAA warnings before attempting to publish the current dataset file version.`;
    } else {
      this.title = 'Unable to apply those changes to a dataset with public files.';
      this.explainer = `Below are the requirements which would be violated were your changes to be applied. 

Unpublish the current dataset file version, then make your changes again.`;
    }

    this.options = dialogData.error.error['detail']['options'].map(
      FilePublicationValidationDialogComponent.StructureOption,
    );
  }

  private static StructureOption(rawOption: RawPublicationOption): PublicationOption {
    const conditions = [];
    for (let i = 0; i < rawOption.conditions.length; i += 2) {
      conditions.push({name: rawOption.conditions[i], met: rawOption.conditions[i + 1]});
    }
    return {name: rawOption.name, conditions};
  }
}
